export const messages = {
  "Home": "Home",
  "Loading metadata": "Loading",
  "Application bootstrap failed": "Application bootstrap failed",
  "Communication failed with the server, please check your internet connection and refresh the page": "Communication failed with the server. Please check your internet connection and refresh the page.",
  "en-US": "English",
  "fr-FR": "French",
  "ht-HT": "Haitian",

  "stats.title": "Voter registration statistics",
  "stats.subtitle": "Current public statistics on registered voters and voter applications.",
  "stats.applicantHighlights": "Key registration indicators",
  "stats.registeredVoters": "Registered voters",
  "stats.applicants": "Applicants",
  "stats.activeOperators": "Active operators",
  "stats.activeCenters": "Active registration centers",
  "stats.configuredCenters": "Registration centers",
  "stats.capacity": "Capacity",
  "stats.capacityUse": "Capacity use",
  "stats.capacityUseByDepartment": "Capacity use by department",
  "stats.capacityUseByDepartmentSubtitle": "Applicants as a share of configured registration capacity.",
  "stats.applicantActivity": "Applicant activity",
  "stats.applicantActivitySubtitle": "Applicant submissions over time.",
  "stats.demographics": "Registered voter demographics",
  "stats.demographicsSubtitle": "Sex and age distribution of registered voters.",
  "stats.sexDistribution": "Sex distribution",
  "stats.ageDistribution": "Age distribution",
  "stats.byDepartment": "Registered voters by department",
  "stats.byDepartmentSubtitle": "Distribution of registered voters across departments.",
  "stats.noData": "No statistics are available.",
  "stats.loading": "Loading",
  "stats.male": "Male",
  "stats.female": "Female",
  "stats.other": "Other",
  "stats.pendingProcessing": "Applications being processed",
  "stats.unknown": "Unknown",
  "stats.under18": "Under 18",
  "stats.18to28": "18 to 28",
  "stats.29to38": "29 to 38",
  "stats.39to48": "39 to 48",
  "stats.49to58": "49 to 58",
  "stats.59to68": "59 to 68",
  "stats.69plus": "69+",
  "reporting.registrationsByDepartment": "Registered voters by department",
  "reporting.standardActivityDepartments": "Distribution of registered voters across departments.",
  "reporting.geoRegistrations": "Geographic distribution of registrations",
  "reporting.geoDrilldownSubtitle": "Distribution and drill-down across electoral geography.",
  "reporting.capacityUtilization": "Capacity utilization",
  "reporting.capacityUtilizationByDepartment": "Capacity utilization by department",
  "reporting.capacityUtilizationByDepartmentSubtitle": "Registered voters as a share of configured registration capacity.",
  "reporting.registeredVoters": "Registered voters",
  "reporting.utilization": "Utilization",
  "reporting.noData": "No reporting data",
  "reporting.high": "High",
  "reporting.low": "Low",
  "geo.capacity": "Capacity",
  "common.unnamed": "Unnamed",
  "common.level": "Level",
  "common.metric": "Metric",
  "common.area": "Area"
};
